var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_42964",
    "data-name": "Group 42964",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16016",
    "data-name": "Rectangle 16016",
    width: 28,
    height: 28,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "volume-off-indicator",
    transform: "translate(1.75 1.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "volume-off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37214",
    "data-name": "Path 37214",
    d: "M19.548,12.182a5.881,5.881,0,0,0-3.384-5.414V9.746l3.384,3.384Zm3.384,0a10.168,10.168,0,0,1-.677,3.519l2.03,2.03a11.392,11.392,0,0,0,1.354-5.685A12.2,12.2,0,0,0,16.164.135V2.978A9.755,9.755,0,0,1,22.932,12.182ZM3.035,0,1.275,1.76,7.637,8.122H1.275v8.122H6.689l6.768,6.768V13.942l5.82,5.82a11.318,11.318,0,0,1-3.113,1.624v2.843a11.558,11.558,0,0,0,5.008-2.436L23.88,24.5l1.76-1.76L13.457,10.558ZM13.457,1.354,10.615,4.2l2.843,2.843Z",
    transform: "translate(-1.275)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMute);
export default __webpack_public_path__ + "static/media/phone-mute.908f90f9f3415a175b2d30da0312b254.svg";
export { ForwardRef as ReactComponent };